import React from "react";
import { useDispatch } from "react-redux";
import { hidePrompt } from "../../../dux/prompt";
import { destroySession } from "../../../helpers/sessionStorageHelper";
import Modal from "../../shared/Modal/Modal";
import CancelIcon from "@mui/icons-material/Cancel";
import { logOutUser } from "../../../dux/login";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import styles from "./GenericError.module.css";

const GenericError = ({ message, status }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeHandler = () => {
    dispatch(hidePrompt());
    if (status === 999) {
      dispatch(logOutUser());
      destroySession();
      navigate("/");
    }
  };

  const handleRetry = () => {
    closeHandler();
    // Reload the page to retry
    window.location.reload();
  };

  const isSessionExpired = status === 999;
  const errorMessage =
    message ||
    "There seems to be a problem. The system is unable to process your request. Please try again in some time.";

  return (
    <Modal>
      <div className={styles.container}>
        <div className={styles.closeButton} onClick={closeHandler}>
          <CancelIcon className={styles.closeIcon} />
        </div>

        <div className={styles.content}>
          <div className={styles.iconContainer}>
            <ErrorOutlineIcon className={styles.errorIcon} />
          </div>

          <h1 className={styles.title}>
            {isSessionExpired
              ? "Session Expired"
              : "Oops! Something went wrong"}
          </h1>

          <p className={styles.message}>{errorMessage}</p>

          <div className={styles.actions}>
            {!isSessionExpired && (
              <button className={styles.retryButton} onClick={handleRetry}>
                <RefreshIcon className={styles.retryIcon} />
                Try Again
              </button>
            )}
            <button className={styles.closeBtn} onClick={closeHandler}>
              {isSessionExpired ? "Go to Home" : "Close"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GenericError;
